function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createMemoStyles } from '@wds/styles';
var MASTHEAD_HEIGHT = '37px';
var useStyles = createMemoStyles(function (_ref) {
  var breakpoints = _ref.breakpoints,
    spacing = _ref.spacing,
    palette = _ref.palette;
  return {
    captiveWindowPage: {
      alignItems: 'center',
      backgroundColor: palette.background,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: '100vh'
    },
    captiveWindowSection: _defineProperty({}, "@media (min-width: ".concat(breakpoints.sm, "px)"), {
      marginTop: 'auto'
    }),
    smLogoHeader: _defineProperty({
      display: 'flex',
      marginTop: spacing[3],
      paddingTop: spacing[4],
      paddingBottom: spacing[6] + spacing[4],
      height: MASTHEAD_HEIGHT
    }, "@media (max-width: ".concat(breakpoints.sm, "px)"), {
      justifyContent: 'center'
    }),
    smLogoHeaderCenter: {
      justifyContent: 'center'
    },
    smLogoLogo: {
      height: MASTHEAD_HEIGHT
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map